<template>
  <div class="invoice-detail-item">
    <form-editor
      ref="Form"
      :data="data"
      :model="formModel"
      @updateModelItem="handlerUpdateModelItem"
    />
  </div>
</template>

<script>
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'
import { api } from '@/services/api'

export default {
  name: 'InvoiceDetailItem',
  mixins: [FormWrapperAutoSave],
  components: {
    'form-editor': () => import(/* webpackChunkName: 'Invoice' */ './FormInvoiceDetail')
  },
  props: {
    data: { type: Object, required: true },
    itemID: { required: true }
  },
  created () {
    this.$bus.$on(`Call-Invoice-Detail-Validate-${this.itemID}`, this.validateItem)
    this.$bus.$on(`Call-Invoice-Detail-Save-${this.itemID}`, this.saveItem)
  },
  beforeDestroy () {
    this.$bus.$off(`Call-Invoice-Detail-Validate-${this.itemID}`, this.validateItem)
    this.$bus.$off(`Call-Invoice-Detail-Save-${this.itemID}`, this.saveItem)
  },
  data () {
    return {
      // eslint-disable-next-line
      apiPatch: 'RFQ3s/Patch/${data.id}'
    }
  },
  computed: {
    isAvailableToSave () {
      return true
    }
  },
  methods: {
    saveItem (callback) {
      let data = this.getFormData()
      api
        .patch(`RFQ3s/Patch/${data.id}`, data)
        .then(() => {
          callback()
        })
        .catch((err) => {
          callback(err)
        })
    },
    validateItem (callback) {
      if (!this.$refs.Form) {
        let message = `not found form for invoice detail ${this.itemID}`
        // eslint-disable-next-line
        console.error(message)
        return callback(new Error(message))
      }
      this.$refs.Form.validate()
        .then(() => {
          callback()
        })
        .catch(() => {
          callback(new Error(`invoice detail ${this.itemID} is invalid`))
        })
    },
    formModel () {
      return {
        id: null,
        partID: null,
        partSN: null,
        qty: 1,
        conditionID: null,
        price: null,
        currencyID: null,
        tagInfoCompanyID: null,
        tagDate: null,
        releaseID: null,
        remarks: null,
        chosen: false
      }
    }
  }
}
</script>
<style lang="stylus">
  .invoice-detail-item{
    border-bottom 1px solid #eeeeef
    padding-top 1rem
    &.is-last{
      border-bottom none
    }
  }
</style>
